<template>
    <v-form
        ref="resetPasswordForm"
        class="form"
        v-model="formValid"
        v-on:submit.prevent
    >
        <v-text-field
            light
            v-model="credentials.password1"
            :rules="password1Rules"
            type="password"
            :label="$t('login.form_reset_password.label_first_password')"
            required
            color="light-blue lighten-2"
        ></v-text-field>
        <v-text-field
            light
            v-model="credentials.password2"
            :rules="password2Rules"
            type="password"
            :label="$t('login.form_reset_password.label_second_password')"
            color="light-blue lighten-2"
            required
        ></v-text-field>
        <v-btn
            light
            :disabled="!formValid"
            :loading="sendingRequest"
            :dark="formValid"
            color="light-blue lighten-2"
            @click="validate"
        >
            {{$t('login.form_reset_password.validate_btn')}}
        </v-btn>
    </v-form>
    
</template>
<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            formValid: true,
            credentials: {
                password1: '',
                password2: '',
                password_modification_token: '',
            },
            sendingRequest: false,
            password1Rules: [
                v => !!v || this.$t('login.form_reset_password.password_rule_required'),
                v => (v && v.length >= 4) || this.$t('login.form_reset_password.password_rule_length')
            ],
            password2Rules: [
                v => !!v || this.$t('login.form_reset_password.password_rule_required'),
                v => (v && v.length >= 4) || this.$t('login.form_reset_password.password_rule_length'),
                v => (v && v === this.credentials.password1) || this.$t('login.form_reset_password.password_rule_match')
            ],
        };
    },
    computed: {
        
    },
    mounted() {},
    methods: {
        validate (){
            if (this.$refs.resetPasswordForm.validate()) {
                this.sendingResetRequest = true;
                this.confirmChangePassword();
            }
        },
        confirmChangePassword() {
            let form = {
                email: this.$route.query.email,
                password1: this.credentials.password1,
                password2: this.credentials.password2,
                password_change_token: this.$route.query.token,
            };
            this.$store.dispatch(
                'changeUserPassword',
                form,
            ).then(
                () => {
                    this.$router.push({name: 'application-list'});
                },
                error => {
                    this.error = error.data.message;
                    this.$notify.error({
                        title: this.texts.password_update_error,
                    });
                },
            );
        },
    },
};

</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Login/form-reset-password.vue